import { CourseSectionsEnum } from 'modules/courses/enums/course-sections-enum'

export const sectionsCourses: CourseSectionsEnum[] = [
  CourseSectionsEnum.courses,
  CourseSectionsEnum.bundles,
  CourseSectionsEnum.students,
  CourseSectionsEnum.assignments,
]
